/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import { AnyAction, isType } from 'typescript-fsa';
import { Album, AlbumSong, MusicbrainzRelease } from '../../../services/playlist';
import {
    albumSetMusicbrainz,
    albumSetMusicbrainzDetails,
    albumSetMusicbrainzLoading,
    setAlbum,
    setAlbumSongs,
    setAlbumUploadedImageId
} from './actions';

export interface AlbumEditState {
    album: Album;
    albumSongs: AlbumSong[];
    albumUploadedImageId?: string;
    musicBrainz: MusicbrainzRelease[];
    musicBrainzIsLoading: boolean;
    albumMap: { [albumId: string]: Album };
    musicBrainzReleaseMap: { [releaseId: string]: MusicbrainzRelease };
}

const initialAlbumEditState: AlbumEditState = {
    album: {
        id: '',
        imageId: '',
        name: '',
        songCount: 0,
        complete: false
    },
    albumSongs: [],
    albumUploadedImageId: undefined,
    musicBrainz: [],
    musicBrainzIsLoading: false,
    albumMap: {},
    musicBrainzReleaseMap: {}
};

export const albumEditReducer = (state: AlbumEditState = initialAlbumEditState, action: AnyAction): AlbumEditState => {
    if (isType(action, setAlbum)) {
        const album = action.payload;
        const albumMap = state.albumMap;
        albumMap[album.id] = album;
        return { ...state, album, albumMap };
    } else if (isType(action, setAlbumSongs)) {
        return Object.assign({}, state, { albumSongs: action.payload });
    } else if (isType(action, setAlbumUploadedImageId)) {
        return Object.assign({}, state, { albumUploadedImageId: action.payload });
    } else if (isType(action, albumSetMusicbrainz)) {
        return { ...state, musicBrainz: action.payload };
    } else if (isType(action, albumSetMusicbrainzDetails)) {
        const release = action.payload;
        const releaseMap = state.musicBrainzReleaseMap;
        releaseMap[release.id] = release;
        return { ...state, musicBrainzReleaseMap: releaseMap };
    } else if (isType(action, albumSetMusicbrainzLoading)) {
        return { ...state, musicBrainzIsLoading: action.payload };
    }

    return state;
};
